import React from 'react';
import { AccordionItem } from '../ui/Accordion';
export function FAQSection() {
  return <section className="py-16 md:py-24 bg-slate-900 px-4" data-id="element-85">
      <div className="max-w-3xl mx-auto" data-id="element-86">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12" data-id="element-87">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-2" data-id="element-88">
          <AccordionItem title="¿Necesito experiencia previa?" data-id="element-89">
            No. El curso está pensado para empezar desde cero. Te explicamos
            paso a paso cómo usar las herramientas y desarrollar el criterio de
            un editor profesional.
          </AccordionItem>

          <AccordionItem title="¿Cuándo accedo al contenido?" data-id="element-90">
            Inmediatamente después del pago. El sistema te enviará
            automáticamente un correo con tus datos de acceso a la plataforma
            para que empieces hoy mismo.
          </AccordionItem>

          <AccordionItem title="¿Sirve si quiero trabajar editando?" data-id="element-91">
            Sí. El contenido es claro y completo para empezar a generar
            ingresos. De hecho, tenemos un módulo entero dedicado a cómo
            conseguir clientes y cobrar por tu trabajo.
          </AccordionItem>

          <AccordionItem title="¿Cómo accedo al curso?" data-id="element-92">
            Te llega un mail con el acceso apenas comprás. Podrás entrar desde
            tu computadora, tablet o celular en cualquier momento.
          </AccordionItem>

          <AccordionItem title="¿Tiene garantía?" data-id="element-93">
            Sí, 7 días de garantía total. Si entras, ves el contenido y sientes
            que no es para ti, puedes pedir el reembolso completo con un solo
            clic, sin preguntas.
          </AccordionItem>
        </div>
      </div>
    </section>;
}